export default "__VITE_ASSET__f284d9bc__"